<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import RealEstateBrokerMobileNavigation from '../components/RealEstateBrokerMobileNavigation.vue';
import RealEstateBrokerDesktopNavigation from '../components/RealEstateBrokerDesktopNavigation.vue';

const { t } = useI18n();
const questions = computed(() => [
  {
    answer: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_1.ANSWER'),
    question: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_1.QUESTION'),
  },
  {
    answer: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_2.ANSWER'),
    question: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_2.QUESTION'),
  },
  {
    answer: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_3.ANSWER'),
    question: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_3.QUESTION'),
  },
  {
    answer: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_4.ANSWER'),
    question: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_4.QUESTION'),
  },
  {
    answer: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_5.ANSWER'),
    question: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_5.QUESTION'),
  },
  {
    answer: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_6.ANSWER'),
    question: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.QUESTION_6.QUESTION'),
  },
]);
</script>

<template>
  <div class="min-h-full bg-lais-bg-soft">
    <LaisHeader
      :title="t('REAL_ESTATE_BROKER_DASHBOARD.HELP.TITLE')"
      :breadcrumb="[
        { label: t('REAL_ESTATE_BROKER_DASHBOARD.TITLE') },
        { label: t('REAL_ESTATE_BROKER_DASHBOARD.HELP.TITLE') },
      ]"
    />
    <div class="mx-auto flex w-full max-w-[1400px]">
      <RealEstateBrokerDesktopNavigation />
      <main class="min-w-0 flex-1 px-4 pb-24 pt-5 sm:px-6 lg:px-10 md:pb-8">
        <section
          class="rounded-lais border border-lais-border-soft bg-white p-5 shadow-lais-card sm:p-8"
        >
          <h2 class="font-redHatDisplay text-xl font-semibold text-lais-text">
            {{ t('REAL_ESTATE_BROKER_DASHBOARD.HELP.FREQUENT_QUESTIONS') }}
          </h2>
          <div class="mt-5 divide-y divide-lais-border-soft">
            <article
              v-for="item in questions"
              :key="item.question"
              class="py-4 first:pt-0 last:pb-0"
            >
              <h3 class="font-semibold text-lais-text">{{ item.question }}</h3>
              <p class="mt-2 text-sm leading-6 text-lais-text-body">
                {{ item.answer }}
              </p>
            </article>
          </div>
        </section>
      </main>
    </div>
    <RealEstateBrokerMobileNavigation />
  </div>
</template>
